<template>
  <div>
    <div v-if="$route.params._field=='720_detail'">
      <div v-show="result.data.fileUrl">
        <iframe :src="result.data.fileUrl" class="iheight"></iframe>
      </div>
    </div>
    <div class="zhu-zi-song" v-show="$route.params._field!='720_detail'">
      <div
        style="margin: auto;width: 100%;padding-top: 80px;height:125px; background-size:100% 100%; "
        v-bind:style="{ 'background-image': 'url(' + result.data.imgUrl + ')' }"
      >
        <el-button
          v-if="result.data.fileUrl!=null"
          style="float: right;margin-right: 15%;background: #e8d9bc;"
          @click="picture(result.data.fileUrl)"
        >全景浏览</el-button>
        <el-button
          v-if="result.data.videoUrl!=null"
          style="float: left;margin-left: 15%;background: #e8d9bc;"
          @click="video(result.data.artiId)"
        >全景视频</el-button>
      </div>
      <div>
        <h3 class="vr-title" v-text="result.data.artiName"></h3>
        <div v-html="result.data.content" class="vr-content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      id: "vr",
      routeType: "arti"
    };
  },
  props: {
    result: {
      type: Object
    },
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    video(Id) {
      window.open(`/mobile/arti/detail/article/whyc/` + Id);
    },
    picture(url) {
      window.open(url);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  mounted() {},
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  created() {},
  watch: {}
};
</script>
<style type="text/scss" lang="scss">
.m-mobile-arti-detail .pan {
  width: 100%;
  height: 400px;
  cursor: pointer;
}
.m-mobile-arti-detail {
  padding-bottom: 100px;
}
.m-mobile-arti-detail .vr-title {
  text-align: center;
  font-size: 17px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  margin: 0 auto;
}
.m-mobile-arti-detail .vr-content {
  font-size: 11px;
  font-family: SourceHanSansCN-Normal;
  font-weight: 400;
  color: #666666;
  line-height: 35px;
  text-indent: 2em;
  padding: 0 15px;
}

.m-mobile-arti-detail .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 15px;
}
.m-mobile-arti-detail .el-tabs__item {
  color: #666666;
}
.m-mobile-arti-detail .el-tabs__nav-wrap {
  margin-bottom: 0 !important;
}
.m-mobile-arti-detail .el-tabs__active-bar {
  background-color: white !important;
}
.m-mobile-arti-detail .el-tabs__item.is-active {
  color: #921a1a;
}
.m-mobile-arti-detail .el-tabs__nav-wrap::after {
  content: "";
  height: none !important;
  background-color: white !important;
}

@media screen and (max-height: 824px) {
  .iheight {
    border: 0;
    height: 755px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 820px) {
  .iheight {
    border: 0;
    height: 752px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 737px) {
  .iheight {
    border: 0;
    height: 676px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 668px) {
  .iheight {
    border: 0;
    height: 608px;
    width: 100%;
    cursor: pointer;
  }
}
@media screen and (max-height: 600px) {
  .iheight {
    border: 0;
    height: 508px;
    width: 100%;
    cursor: pointer;
  }
}
.vf-link-praise {
  color: #fff;
  height: 41px;
  line-height: 41px;
  font-size: 14px;
  display: inline-block;
  float: right;
  margin-right: 10px;
  border: none;
  background: none;
  padding: 0px;
}

.vf-link-praise.del {
  text-decoration: line-through;
}
</style>